import { TableData } from '../../../shared/types/api-response.types';
import { CommodityType, Status } from '@ui/aos-lib';
import {
  EventConfigurationActivityType,
  EventConfigurationAPIItem,
  EventConfigurationSeverityRule
} from './services/event-configuration-api.type';

interface EventConfigurationTrigger {
  readonly activityType: EventConfigurationActivityType;
  readonly severityOperator: '<' | '>';
}

export interface EventConfiguration {
  readonly description: string;
  readonly deviceType: EventConfigurationAPIItem['deviceType'];
  readonly deviceTypeName: string; // TODO: Should we use an enum with 'Any', 'Base Station', 'Sensor'…?
  readonly eventConfigurationStatus: Status;
  readonly eventGroup: string;
  readonly eventTypeId: number;
  readonly isEnabled: boolean;
  readonly lastUpdateTimestamp: string;
  readonly name: string;
  readonly severityRules: EventConfigurationAPIItem['severityRules'];
  readonly critical: EventConfigurationSeverityRule | string;
  readonly severe: EventConfigurationSeverityRule | string;
  readonly warning: EventConfigurationSeverityRule | string;
  readonly notice: EventConfigurationSeverityRule | string;
  readonly trigger: EventConfigurationTrigger;
  readonly unitOfMeasure: string;
  readonly updatedBy: string;
  readonly commodity: CommodityType;
}

export type EventConfigurationTable = TableData<EventConfiguration>;

export enum EventConfigurationFieldName {
  DeviceType = 'DeviceType',
  Name = 'name',
  SeverityLevel = 'SeverityLevel',
  IsEnabled = 'IsEnabled',
  LastUpdateTimestamp = 'UpdatedOnUtc',
  EventGroup = 'EventGroup',
  Description = 'Description',
  Commodity = 'Commodity',
  UpdatedBy = 'UpdatedBy',
  UpdatedOnUtc = 'UpdatedOnUtc',
  UnitOfMeasure = 'UnitOfMeasure',
  SeverityType = 'SeverityType'
}

export enum SeverityTypeFilterValue {
  All = 'All',
  Single = 'Single',
  Multiple = 'Multiple'
}

export enum StatusFilterModelItems {
  ACTIVE = 'true',
  INACTIVE = 'false'
}
